import { useEffect, useState } from 'react'

// Ported from fleerp-ops mobile (hooks/useDebounce.ts). Returns a value that
// trails `value` by `delay` ms; the pending update is cancelled whenever
// `value` (or `delay`) changes before the timer fires.
export function useDebounce<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState<T>(value)

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(handle)
  }, [value, delay])

  return debounced
}
